<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-09 17:32:06
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-03-17 09:43:43
 * @Description: 
-->
<template>
  <div class="bg-#f8fbff text-#0f172a min-h-screen">
    <m-header />
    <slot></slot>
    <m-footer />
    <scroll-to-top />
  </div>
</template>

<script setup lang="ts">
  defineOptions({
    name: 'DefaultLayout',
  })

  provideHuiguanjiaHome()
</script>
<style scoped lang="scss"></style>
